import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { articleImages } from '@/mocks/images';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const imageUrl = articleImages[article.slug] || '';

  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="aspect-[5/3] overflow-hidden bg-background-100">
          <img
            src={imageUrl}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
        <Link to={`/article/${article.slug}`}>
          <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex flex-wrap gap-2">
          {article.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}